import styled from 'styled-components';

export const Heading = styled.h1`
    font-weight: bold;
    margin-top: 0px;
    padding-top: 16px;
    text-align: center;
`;